import { useQuery } from '@apollo/client';
import {
  IObjektVyComp,
  IBusinessCollectionProps,
} from '../../../../../../Types/ObjektVy';
import {
  FakturaDok,
  FakturaDokVariables,
} from '../Queries/_QueryTypes/FakturaDok';
import FakturaDokQuery from '../Queries/FakturaDokQuery.gql';
import Documents, {
  getDocumentUrl,
} from '../../../../../../Components/Documents/Documents';
import Logger from '../../../../../../Utils/Logger';
import EDAvenyProgress from '../../../../../../BaseComponents/ProgressIndicators/AvenyProgress/EDAvenyProgress';
import { selectedId } from '../../../../../../Components/MasterDetail/MasterDetailUtils';

const FakturaDokOkjektVyComp: IObjektVyComp = {
  caption: 'Dokument',
  comp: (props: IBusinessCollectionProps) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, loading, error } = useQuery<FakturaDok, FakturaDokVariables>(
      FakturaDokQuery,
      { variables: { id: selectedId(props.id) || '' }, skip: props.id == null }
    );

    const fakturaDok =
      data?.node?.__typename === 'TEDLRFakturaDok' ? data?.node : null;

    if (loading) {
      return <EDAvenyProgress />;
    } else if (error) {
      const message = `Fel vid hämtning av fakturadokument: ${error.message}`;
      Logger.error(message);
      return <p>{message}</p>;
    } else if (fakturaDok == null) {
      const message = `Fel vid hämtning av fakturadokument: Hittade inget dokument att visa`;
      Logger.error(message);
      return <p>{message}</p>;
    } else if (fakturaDok.EXTENSION == null) {
      const message = `Fel vid hämtning av fakturadokument: Extension saknas`;
      Logger.error(message);
      return <p>{message}</p>;
    } else if (fakturaDok.BINARDATA == null) {
      const message = `Fel vid hämtning av fakturadokument: Blob ID saknas`;
      Logger.error(message);
      return <p>{message}</p>;
    } else {
      const fileName = fakturaDok.BESKRIVNING || 'Saknar beskriving';

      return (
        <Documents
          documents={[
            {
              url: getDocumentUrl(fakturaDok.BINARDATA),
              extension: fakturaDok.EXTENSION,
              fileName,
            },
          ]}
          imageFullscreenTitle={fileName}
        />
      );
    }
  },
};

export default FakturaDokOkjektVyComp;
